import { IRoles } from "src/utils";

const ORG_SENDER_TYPES = new Set(["user", "company"]);

export const isEmployeeRole = (role?: string | null) => role === IRoles.Employee;

export const getJobChatCompanyDisplayName = (company?: { businessName?: string | null; name?: string | null }) =>
  company?.businessName?.trim() || company?.name?.trim() || "Company";

export const maskJobChatSenderForEmployee = (
  message: any,
  sender: any,
  companyDisplayName: string,
  currentRole?: string | null,
) => {
  if (!isEmployeeRole(currentRole)) {
    return message;
  }

  const senderType = message?.sender?.type;
  const senderUid = message?.sender?.uid;
  const isOwn =
    sender &&
    ((sender.type === "workforce" && sender.uid && senderUid === sender.uid) ||
      (Array.isArray(sender) &&
        sender.some((entry: any) => entry?.type === "workforce" && entry?.uid === senderUid)));

  if (isOwn || !ORG_SENDER_TYPES.has(senderType)) {
    return message;
  }

  return {
    ...message,
    sender: {
      ...message.sender,
      firstName: companyDisplayName,
      lastName: "",
      businessName: companyDisplayName,
      roleType: "Company",
    },
  };
};
